import axios from 'axios';

import settings from '../libs/config';
import Logger from '../functions/logging';
import ApiError from './apiError.js';

const endpointGetPanel = settings.api_host + "/panel/get";

export const getStudyPanel = async (panel_id, survey_id, user_token) => {
	if (!panel_id && !survey_id) {
		if (!panel_id) throw new Error("Missing Panel ID");
		if (!survey_id) throw new Error("Missing Survey ID");
	}
	Logger.log(this.constructor.name, "getStudyPanel() PANEL ID:", panel_id || survey_id, "ENDPOINT:", endpointGetPanel);

	try {
		const response = await axios.get(endpointGetPanel, {
			params: {
				panel_id,
				survey_id,
				user_token
			}
		});
		// Logger.log(this.constructor.name, "getStudyPanel() response", response);
		const data = response.data;
		return data.result;
	} 
	catch (error) {
		throw new ApiError(error);
	}
};


// WEBPACK FOOTER //
// ./src/api/panels.js